module.exports = __webpack_public_path__ + "img/tiktok-footer.f40bbf60.svg";